module.exports = __webpack_public_path__ + "static/media/omega.9d706c6c.svg";